<app-linkable
    typename="findings"
    [displayValueProp]="displayValueProp"
    [linked]="linked"
    [unlinked]="unlinked"
    [orderByValueProperty]="true"
    [disabled]="disabled"
    [hideActions]="hideActions"
    [hideFilter]="hideFilter"
    [allowAddNew]="allowAddNew"
    [rowIconConfig]="rowIconConfig"
    [rendererConfig]="rendererConfig"
    (onOpenClicked)="openItem($event)"
    [allowEditItem]="allowEditItem"
    [allowBatchEdit]="allowBatchEdit"
    [allowOpenItem]="true"
>
</app-linkable>
